import React from "react";
import "./PolicyPage.scss";



const PolicyPage = () => (

  <div className="policy-container">
    <h1 className="heading">Privacy Policy</h1>
    <h2>Privacy Policy</h2>
<p><strong>Effective Date: 1st May 2025</strong></p>

<p>Aerial Borne (“we”, “our”, or “us”) respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your data when you use our platform—whether as a customer or a certified drone operator.</p>

<p>By accessing or using Aerial Borne, you agree to this Privacy Policy.</p>


    <h2>Information We Collect</h2>

<h3>a. Information You Provide</h3>
<p>We collect information you provide directly to us when you:</p>
<ul>
  <li>Create an account (customer or operator)</li>
  <li>Submit a service request or proposal</li>
  <li>Communicate via chat or messages on the platform</li>
  <li>Participate in surveys, feedback forms, or support channels</li>
</ul>

<p>This may include:</p>
<ul>
  <li>Full name</li>
  <li>Email address</li>
  <li>Phone number</li>
  <li>Company/organization name</li>
  <li>Billing and payment information</li>
  <li>Drone operator certification details</li>
  <li>Project details and service history</li>
  <li>Communications and attachments</li>
</ul>

<h3>b. Automatically Collected Information</h3>
<p>When you use the platform, we automatically collect:</p>
<ul>
  <li>IP address</li>
  <li>Device type and operating system</li>
  <li>Browser type and version</li>
  <li>Usage data (pages visited, time spent, navigation)</li>
  <li>Location data (if permitted by your device)</li>
</ul>

<h3>c. Cookies and Tracking Technologies</h3>
<p>We use cookies and similar tracking tools to enhance your user experience, remember your preferences, and analyze site performance.</p>


    <h2>How We Use Your Information</h2>
    <ul>
      <li>Operate, maintain, and improve our platform</li>
      <li>Match customers with suitable certified operators</li>
      <li>Verify pilot certifications and compliance</li>
      <li>Communicate with you about your account, updates, and support</li>
      <li>Process transactions and payments securely</li>
      <li>Comply with legal and regulatory obligations</li>
      <li>Prevent fraud, misuse, or unauthorized access</li>
      <li>Customize your experience and service recommendations</li>
    </ul>


    <h2>Sharing and Disclosure</h2>
    <p><strong>We do not sell</strong> your personal information.</p>
    <p>We may share your data with:</p>
    <ul>
      <li><strong>Certified drone operators or customers</strong> (only when matched or during a project)</li>
      <li><strong>Service providers</strong> (payment processors, analytics, hosting partners)</li>
      <li><strong>Regulatory authorities</strong> when required by law or in compliance with DGCA or local aviation rules</li>
      <li><strong>Affiliates or business partners</strong> (under strict confidentiality obligations)</li>
      <li><strong>Law enforcement</strong> or third parties if required to protect rights, safety, or to comply with a legal process</li>
    </ul>
    <p>All shared data is limited to what is necessary for the relevant purpose.</p>


    <h2>Your Rights and Choices</h2>
    <p>Depending on your jurisdiction, you may have rights including:</p>
    <ul>
      <li>Accessing the personal data we hold about you</li>
      <li>Requesting correction of inaccurate information</li>
      <li>Requesting deletion of your data (“right to be forgotten”)</li>
      <li>Objecting to or restricting processing</li>
      <li>Withdrawing consent (where processing is based on consent)</li>
      <li>Data portability requests</li>
    </ul>
    <p>To exercise these rights, contact us at <strong>support@aerialborne.com</strong>. We will respond within applicable legal timeframes.</p>

    <h2>Data Retention</h2>
    <p>We retain your data only as long as necessary to:</p>
    <ul>
      <li>Provide you with services</li>
      <li>Fulfill legal and contractual obligations</li>
      <li>Enforce our agreements</li>
      <li>Maintain records for audit and regulatory compliance</li>
    </ul>
    <p>After that, data is securely deleted or anonymized.</p>

    <h2>Data Security</h2>
    <p>We implement industry-standard technical and organizational measures to safeguard your data from unauthorized access, disclosure, alteration, or destruction.</p>
    <p>These include:</p>
    <ul>
      <li>Secure encryption (TLS/SSL)</li>
      <li>Access control and authentication protocols</li>
      <li>Regular security audits and vulnerability scans</li>
      <li>Encrypted data storage for sensitive information</li>
    </ul>
    <p>While no system is 100% secure, we take your data protection seriously and continuously improve our safeguards.</p>

    <h2>Children’s Privacy</h2>
    <p>Aerial Borne is not intended for use by individuals under the age of 18. We do not knowingly collect personal information from minors. If we become aware of such data, we will delete it promptly.</p>

    <h2>International Transfers</h2>
    <p>If you access Aerial Borne from outside India, your information may be transferred to, stored, or processed in India or other jurisdictions where our servers or partners are located. We ensure such transfers comply with applicable data protection laws.</p>

    <h2>Third-Party Services and Links</h2>
    <p>Our platform may contain links to third-party websites or services. We are not responsible for their privacy practices. Please review their policies before submitting your information.</p>

    <h2>Changes to This Privacy Policy</h2>
    <p>We may update this Privacy Policy periodically. We will notify you of significant changes via email or platform notification. Continued use of the platform indicates acceptance of the revised policy.</p>

    <h2>Contact Us</h2>
    <p>If you have questions, concerns, or complaints about this policy or your data, contact us at:</p>

    <p><strong>Aerial Borne Support</strong></p>
    <p>📩 Email: <a href="mailto:support@aerialborne.com">support@aerialborne.com</a></p>
    <p>📞 Phone: <a href="tel:+917357017420">+91-7357017420</a></p>
    <p>📍 Address: <strong>2nd Floor Plot No.4, Minarch Tower Sector-44, Gurgaon, Haryana, India,
      <a href="https://www.falconebiz.com/company/122003.html" target="_blank">122003</a></strong></p>


  </div>

);

export default PolicyPage;
